import { render, staticRenderFns } from "./RegistrationStatus.vue?vue&type=template&id=5c1189a4&scoped=true&"
import script from "./RegistrationStatus.vue?vue&type=script&lang=js&"
export * from "./RegistrationStatus.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationStatus.vue?vue&type=style&index=0&id=5c1189a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1189a4",
  null
  
)

export default component.exports